import PGEntityCoreClient from '@/clients/PGEntityCoreClient'
import PGMonolithClient from '@/clients/PGMonolithClient'

export default class PGServiceClient {
  constructor (practiceUuid) {
    this.entityClient = new PGEntityCoreClient(practiceUuid)
    this.monolithClient = new PGMonolithClient()
  }

  getLocations () {
    return this.entityClient.getLocations()
  }

  async getProviders (locationUuid, legacyPracticeId, legacyLocationId) {
    const { data } = await this.entityClient.getProviders(locationUuid)
    const providers = data.providers || []

    if (legacyPracticeId && legacyLocationId) {
      try {
        const photos = await this.monolithClient.getProviderPhotos(legacyPracticeId, legacyLocationId)
        const photoMap = new Map(photos.map(p => [p.id, p.profile_img]))
        providers.forEach(p => {
          if (p.legacyProviderId != null) {
            const img = photoMap.get(p.legacyProviderId)
            if (img) p.photoUrl = img
          }
        })
      } catch (error) {
        console.error('Failed to hydrate provider photos', error)
      }
    }

    return { data: { providers } }
  }

  submitReview (params) {
    return this.monolithClient.submitReview(params)
  }

  getReviewRouting (params) {
    return this.monolithClient.getReviewRouting(params)
  }

  updateCampaignRecipient (campaignId, recipientId, payload) {
    return this.monolithClient.updateCampaignRecipient(campaignId, recipientId, payload)
  }
}
